/* eslint-disable react/prop-types */
import { colors, strCode } from "../../../consts";
import { t } from "../../../services";

import {
  FlexContainers,
  GradientLoader,
  IconButton,
  SVG,
  TableItemsCounter,
  TextOverflowWrapper,
  WrapperContainer
} from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";
import { HardwareIconContainer } from "../HardwareTable/styled";

export const LocationHardwareTableColumns = (isMercury) => {
  return [
    {
      Header: strCode.LOCATION_TITLE,
      accessor: "locationName",
      Cell: ({ cell, isLoading, searchedText }) => {
        return (
          <CellWrapper width={`300px`} maxWidth={"300px"}>
            <WrapperContainer Container={FlexContainers.FlexRowStart} gap={16}>
              {isLoading ? (
                <GradientLoader width={40} height={40} animationDuration={40} borderRadius={8} />
              ) : (
                <HardwareIconContainer Container={FlexContainers.FlexRowCenter}>
                  <SVG.HardwareLocationIcon />
                </HardwareIconContainer>
              )}

              <TextOverflowWrapper
                style={{ color: colors.RAISIN_100, fontWeight: 600 }}
                highlightedText={searchedText}>
                {isLoading ? (
                  <GradientLoader width={"120px"} height={24} animationDuration={40} />
                ) : (
                  cell?.value
                )}
              </TextOverflowWrapper>
            </WrapperContainer>
          </CellWrapper>
        );
      }
    },
    {
      Header: isMercury ? strCode.MAC_ADDRESS_TITLE : strCode.ID_TITLE,
      accessor: "hardware",
      Cell: ({ cell, cellWidth5, isLoading }) => {
        const hardware = isMercury
          ? cell.value?.map((el) => el?.slice(0, 17))
          : cell.value?.map((el) => el?.slice(-8));
        const hardwareCount = hardware?.length;

        return (
          <CellWrapper minWidth={cellWidth5} width={cellWidth5}>
            <TextOverflowWrapper
              lines={2}
              style={{ color: hardwareCount ? colors.RAISIN_70 : colors.RAISIN_50 }}>
              {isLoading ? (
                <GradientLoader width={cellWidth5} height={24} animationDuration={40} />
              ) : hardwareCount ? (
                <>
                  {hardwareCount <= 8 ? (
                    hardware.join(", ")
                  ) : (
                    <>
                      {hardware.slice(0, 8).join(", ")}
                      <TableItemsCounter appsCount={hardwareCount - 8} />
                    </>
                  )}
                </>
              ) : (
                t(strCode.NO_ASSIGNED_HARDWARES_INFO)
              )}
            </TextOverflowWrapper>
          </CellWrapper>
        );
      }
    },

    {
      Header: "",
      id: "control",
      accessor: "id",
      Cell: ({ cell, isLoading, callbackFn1: onAssign }) => {
        const originalRow = cell.row.original;

        return (
          <CellWrapper width={"100%"}>
            {!isLoading && (
              <WrapperContainer Container={FlexContainers.FlexRowEnd} width={"100%"} pr={24}>
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    onAssign(originalRow);
                  }}
                  tooltipLabel={t(strCode.ASSIGN_BTN)}>
                  <SVG.EditIcon />
                </IconButton>
              </WrapperContainer>
            )}
          </CellWrapper>
        );
      }
    }
  ];
};
